
/**
* @component Content
*
* Center content within supported breakpoints.
* @deprecated Use container mixin from ui-kit\styles\mixins.scss
* @note we could add maximum breakpoints prop
*
* @public
*/

export default {
  name: 'ContentComponent',
};
